import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'faire_direct-invalid_faire_direct_path-action_category_error';

/**
 * This event tracks when the Faire Direct path is invalid.
 */
export function trackFaireDirectInvalidFaireDirectPathActionCategoryError(
  brandToken: string,
  pathname: string,
  source2: string,
  queryParams3: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { brandToken, pathname, source2, queryParams3 },
  });
}
